<div class="sas-related-item__main">
  <div class="sas-related-item__left">
    <span class="sas-related-item__kind">{{ kind() }}</span>
    @if (empty()) {
      <span class="sas-related-item__ref">{{ ref() }}</span>
    } @else {
      <sas-button class="sas-related-item__ref"
                  type="link"
                  [underline]="refClickable()"
                  [text]="ref()"
                  [ariaLabel]="ariaLabel() ?? ''"
                  (sasOnClick)="sasAction.emit()">
      </sas-button>
    }
  </div>

  @if (!empty() && !refClickable()) {
    <span class="sas-related-item__action" aria-hidden="true">{{ actionLabel() }}</span>
  }

  @if (dismissible()) {
    <sas-button class="sas-related-item__dismiss"
                type="ghost"
                size="sm"
                icon="bi-x"
                [text]="dismissLabel()"
                [iconOnly]="true"
                (sasOnClick)="sasDismiss.emit($event)">
    </sas-button>
  }
</div>

@if (meta()) {
  <span class="sas-related-item__meta">{{ meta() }}</span>
}
